export const PRODUCT_FILED_LIST = ["product_name", "product_area", "product_category", "description", "product_image"];
